import { ComposerPrimitive } from '@assistant-ui/react';
import { useRouter } from 'next/router';

import { FarIcons } from '@playbooks/icons';
import { Button } from '@playbooks/ui/components/button';
import { StructuralIcon } from '@playbooks/ui/components/structural-icon';

import { ComposerActionRow, ComposerActionSection } from 'components/composer/composer-actions-components';
import { FlowBody } from 'utils/flow';

const ComposerActionsSelect = ({ type = 'app', disabled = false, composerSummary = '', onView }) => {
	const router = useRouter();

	// Computed
	const isWorkspace = type === 'workspace';
	const isAgent = type === 'agent';

	// Render
	return (
		<FlowBody>
			<div className='divide-y divide-border'>
				<ComposerActionSection>
					{disabled ? (
						<Button variant='ghost' size='sm' disabled className='w-full justify-start px-2.5'>
							<StructuralIcon data-icon='inline-start' icon={FarIcons.farPaperclip} aria-hidden />
							Attach file
						</Button>
					) : (
						<ComposerPrimitive.AddAttachment multiple asChild>
							<Button variant='ghost' size='sm' className='w-full justify-start px-2.5'>
								<StructuralIcon data-icon='inline-start' icon={FarIcons.farPaperclip} aria-hidden />
								Attach file
							</Button>
						</ComposerPrimitive.AddAttachment>
					)}
				</ComposerActionSection>
				<ComposerActionSection>
					<ComposerActionRow
						icon={FarIcons.farRobot}
						label='Composer'
						value={composerSummary}
						onClick={() => onView('composer')}
					/>
					{!isWorkspace ? (
						<>
							<ComposerActionRow
								icon={FarIcons.farBrush}
								label='Design'
								onClick={() =>
									isAgent ? router.push(`/agents/${router.query.agentId}/settings/designs`) : onView('design')
								}
							/>
							<ComposerActionRow
								icon={FarIcons.farSparkles}
								label='Skills'
								onClick={() =>
									isAgent ? router.push(`/agents/${router.query.agentId}/settings/skills`) : onView('skills')
								}
							/>
						</>
					) : null}
					<ComposerActionRow
						icon={FarIcons.farWrench}
						label='Tools'
						value={isAgent ? 'Unavailable' : undefined}
						disabled={isAgent}
						onClick={() => onView('tools')}
					/>
					{!isWorkspace ? (
						<>
							<ComposerActionRow
								icon={FarIcons.farPlug}
								label='Connectors'
								onClick={() =>
									isAgent ? router.push(`/agents/${router.query.agentId}/connectors`) : onView('connectors')
								}
							/>
							<ComposerActionRow
								icon={FarIcons.farServer}
								label='MCPs'
								value={isAgent ? 'Unavailable' : undefined}
								disabled={isAgent}
								onClick={() => onView('mcps')}
							/>
						</>
					) : null}
				</ComposerActionSection>
			</div>
		</FlowBody>
	);
};

export { ComposerActionsSelect };
